/**
 * Script pour ajouter les éléments de réassurance entre prix et couleur
 * Version simplifiée avec logs de débogage
 */

(function() {
  'use strict';
  
  console.log('🔵 Script réassurance chargé');
  
  // Détecter la langue
  function getLanguage() {
    // Méthode 1: Via l'attribut lang du HTML
    const htmlLang = document.documentElement.lang || document.documentElement.getAttribute('lang');
    if (htmlLang) {
      const lang = htmlLang.split('-')[0].toLowerCase();
      if (['fr', 'en', 'es', 'de'].includes(lang)) {
        return lang;
      }
    }
    
    // Méthode 2: Via l'URL
    const path = window.location.pathname;
    if (path.includes('/fr/') || path.startsWith('/fr')) return 'fr';
    if (path.includes('/en/') || path.startsWith('/en')) return 'en';
    if (path.includes('/es/') || path.startsWith('/es')) return 'es';
    if (path.includes('/de/') || path.startsWith('/de')) return 'de';
    
    // Méthode 3: Via Shopify locale
    if (window.Shopify && window.Shopify.locale) {
      const locale = window.Shopify.locale.split('-')[0].toLowerCase();
      if (['fr', 'en', 'es', 'de'].includes(locale)) {
        return locale;
      }
    }
    
    // Par défaut: français
    return 'fr';
  }
  
  // Traductions
  const translations = {
    fr: {
      payment: 'Paiement sécurisé',
      delivery: 'Livraison gratuite en Europe dès 50€ d\'achat',
      shipping: 'Retour gratuit en Europe dès 50€ d\'achat',
      warranty: 'Garantie à vie'
    },
    en: {
      payment: 'Secure payment',
      delivery: 'Free delivery in Europe from €50 purchase',
      shipping: 'Free return in Europe from €50 purchase',
      warranty: 'Lifetime warranty'
    },
    es: {
      payment: 'Pago seguro',
      delivery: 'Envío gratuito en Europa desde 50€ de compra',
      shipping: 'Devolución gratuita en Europa desde 50€ de compra',
      warranty: 'Garantía de por vida'
    },
    de: {
      payment: 'Sichere Zahlung',
      delivery: 'Kostenloser Versand in Europa ab 50€ Einkauf',
      shipping: 'Kostenlose Rückgabe in Europa ab 50€ Einkauf',
      warranty: 'Lebenslange Garantie'
    }
  };
  
  function insertReassurance() {
    // Vérifier si déjà présent
    if (document.querySelector('.product-reassurance')) {
      console.log('✅ Déjà présent');
      return;
    }
    
    console.log('🔍 Recherche du bouton CTA et de la description...');
    
    // Détecter la langue
    const lang = getLanguage();
    const texts = translations[lang] || translations.fr;
    console.log('🌍 Langue détectée:', lang);
    
    // Chercher le bouton CTA
    const buyButton = document.querySelector('.product-buy-buttons--cta');
    
    // Chercher la description
    const description = document.querySelector('.product-page--description');
    
    if (!buyButton) {
      console.log('❌ Bouton CTA non trouvé, réessai dans 500ms...');
      setTimeout(insertReassurance, 500);
      return;
    }
    
    if (!description) {
      console.log('❌ Description non trouvée, réessai dans 500ms...');
      setTimeout(insertReassurance, 500);
      return;
    }
    
    console.log('✅ Bouton CTA et description trouvés');
    
    // Chercher le parent de la description
    const descriptionParent = description.parentElement;
    
    if (!descriptionParent) {
      console.log('❌ Pas de parent pour la description');
      return;
    }
    
    console.log('✅ Insertion en cours...');
    
    // Construire le HTML sans garantie
    const html = '<div class="product-reassurance-item"><div class="product-reassurance-icon"><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z"/><path d="M9 12l2 2 4-4"/></svg></div><span class="product-reassurance-text">' + texts.payment + '</span></div><div class="product-reassurance-item"><div class="product-reassurance-icon"><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z"/></svg></div><a href="https://haize-project.com/pages/condition-de-livraisons-et-taxes" target="_blank" rel="noopener noreferrer" class="product-reassurance-text product-reassurance-link">' + texts.delivery + '</a></div><div class="product-reassurance-item"><div class="product-reassurance-icon"><svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M9 12l-4-4 4-4m6 8l4-4-4-4" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg></div><a href="https://haize-project.com/pages/politique-de-retour" target="_blank" rel="noopener noreferrer" class="product-reassurance-text product-reassurance-link">' + texts.shipping + '</a></div>';
    
    // Créer le conteneur de réassurance avec les traductions
    const reassuranceContainer = document.createElement('div');
    reassuranceContainer.className = 'product-reassurance';
    reassuranceContainer.innerHTML = html;
    
    try {
      // Insérer directement avant la description (en ignorant tout bloc intermédiaire)
      descriptionParent.insertBefore(reassuranceContainer, description);
      console.log('✅ Élément inséré directement avant la description');
    } catch(e) {
      console.error('❌ Erreur lors de l\'insertion:', e);
    }
  }
  
  // Exécuter au chargement
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      console.log('📄 DOMContentLoaded');
      insertReassurance();
    });
  } else {
    console.log('📄 DOM déjà chargé');
    insertReassurance();
  }
  
  // Réessayer avec des délais
  setTimeout(function() {
    console.log('⏰ Réessai après 300ms');
    insertReassurance();
  }, 300);
  
  setTimeout(function() {
    console.log('⏰ Réessai après 1000ms');
    insertReassurance();
  }, 1000);
  
  setTimeout(function() {
    console.log('⏰ Réessai après 2000ms');
    insertReassurance();
  }, 2000);
  
  // Observer les mutations
  if (window.MutationObserver) {
    const observer = new MutationObserver(function() {
      if (!document.querySelector('.product-reassurance')) {
        console.log('🔄 Mutation détectée, réessai...');
        insertReassurance();
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    console.log('👀 MutationObserver activé');
  }
})();

